import { Component, inject } from '@angular/core';
import { RouterModule } from '@angular/router';

import { ProfileService } from '@core/profile.service';

@Component({
  imports: [RouterModule],
  selector: 'norupe-app-login',
  styles: ``,
  templateUrl: './login.component.html',
})
export class LoginComponent {
  private profileSrv = inject(ProfileService);
  loginUrl = this.profileSrv.loginUrl;
}
